import { render, staticRenderFns } from "./ProjectContent.vue?vue&type=template&id=0132b037&scoped=true"
import script from "./ProjectContent.vue?vue&type=script&lang=ts"
export * from "./ProjectContent.vue?vue&type=script&lang=ts"
import style0 from "./ProjectContent.vue?vue&type=style&index=0&id=0132b037&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132b037",
  null
  
)

export default component.exports